import React from 'react';
import Styles from './my-portfolio-real-estate-house-type.scss';
import InfoCard from '../my-porfolio-real-estate-info-card/my-porfolio-real-estate-info-card';
import { ButtonKVBase } from '@/presentation/components';
const HouseType = ({ realEstate, onSetCurrentRealEstate }) => {
    var _a, _b;
    return (React.createElement("div", { className: Styles.houseTypeContainer },
        React.createElement("div", { className: Styles.title }, (_a = realEstate === null || realEstate === void 0 ? void 0 : realEstate.property) === null || _a === void 0 ? void 0 : _a.name),
        React.createElement("div", { className: Styles.flexContainer },
            React.createElement("div", { className: Styles.houseImgContainer },
                React.createElement("img", { src: `https://app.dev.kidvestors.co/${(_b = realEstate === null || realEstate === void 0 ? void 0 : realEstate.property) === null || _b === void 0 ? void 0 : _b.imagePath}`, alt: "" })),
            React.createElement("div", { className: Styles.detailsContainer },
                React.createElement(InfoCard, { realEstate: realEstate }),
                React.createElement(ButtonKVBase, { onClick: () => onSetCurrentRealEstate(realEstate), type: "button", btnBackgroundGradient: "linear-gradient(90deg, #00A3FF 0%, #7000FF 100%)" }, 'View Statement')))));
};
export default HouseType;
